import { FC, useEffect, useState } from 'react'
import { FieldWithOutLabel } from '../../../../../modules/ui/FieldWithOutLabel'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import { useQueryGetRoles } from '../../../../../../queries/roleQueries'
import { SelectFieldWithSearch } from '../../../../../modules/ui/SelectWithSearch'
import { sileo } from 'sileo'
import { useMutationInviteUser } from '../../../../../../queries/userQueries'
// import { useGlobalContext } from '../../../../../../context/GlobalState'
// import { IBusiness } from '../../../../../../models/Business'
import PlanRestrictedButton from '../../../../../../components/modules/ui/PlanRestrictedButton'

interface FormValues {
  email: string
  role?: {
    name: string
    id: number
  }
}

const schemmaValidation = Yup.object<FormValues>({
  email: Yup.string().email('Ingresa un correo valido').required('No puede estar vacio'),
  role: Yup.object({
    name: Yup.string().required('No puede estar vacio')
  })
})

export const FormInviteUser: FC = () => {
  // const { currentBusiness } = useGlobalContext()
  const { data: roles = [], isSuccess } = useQueryGetRoles()
  // const { data: userMe } = useQueryGetUserMe()
  const [initialValues, setInitialValues] = useState<FormValues>({ email: '' })
  const inviteUser = useMutationInviteUser()
  console.log(roles)
  useEffect(() => {
    if (isSuccess && roles) {
      setInitialValues({
        email: '',
        role: {
          name: roles[1]?.name,
          id: roles[1]?.id
        }
      })
    }
  }, [isSuccess])

  return (
    <div className='flex flex-col gap-3 w-full'>
      <Formik
        enableReinitialize={true}
        validationSchema={schemmaValidation}
        initialValues={initialValues}
        onSubmit={async values => {
          if (values.role?.id) {
            const promise = inviteUser.mutateAsync(values)
            try {
              await sileo.promise(promise, {
                loading: { title: 'Invitando Usuario' },
                success: {
                  title: 'Invitación Enviada',
                  description: (
                    <span className='text-green-500/80 font-medium'>
                      Hemos enviado un correo de invitación 👌
                    </span>
                  )
                },
                error: {
                  title: 'Error de Invitación',
                  description: 'No se pudo invitar al usuario 🤯'
                }
              })
              sileo.success({
                title: 'Registro Pendiente',
                description: (
                  <span className='text-green-500/80 font-medium'>
                    Hazle saber a tu invitado que complete su registro 👌
                  </span>
                )
              })
            } catch (error) {
              return null
            }
          }
        }}
      >
        <Form>
          <ul className='grid grid-cols-1 gap-3 w-full max-w-xs'>
            {/* <li>
              <div>
                <h4 className='font-bold'>Nombres y Apellidos</h4>
                <p>{userMe?.firstname} {userMe?.lastname}</p>
              </div>
            </li> */}

            <li className='w-full'>
              <FieldWithOutLabel
                name='email'
                placeholder='Ingresa Correo Electronico'
                type='email'
              />
            </li>

            {/* <li>
              <div>
                <h4 className='font-bold'>Perfil</h4>
                <p>{userMe?.role?.name}</p>
              </div>
            </li> */}

            <li className='w-full'>
              <SelectFieldWithSearch
                label='Rol'
                name='role'
                placeholder='Role'
                options={roles?.map(role => ({
                  id: role?.id,
                  name: role?.name
                }))}
              />
            </li>

            {/* <li>
              <div>
                <h4 className='font-bold'>Rut</h4>
                <p>{(currentBusiness as any as IBusiness)?.rut}</p>
              </div>
            </li> */}
            <PlanRestrictedButton
              requiredPermission="allowMultiUsers"
              message="La invitación de usuarios"
              keepEnabled={true}
            >
              <button
                type='submit'
                className='w-full mt-4 rounded-full shadow-card text-sm font-semibold flex items-center justify-center gap-2 bg-success text-white hover:bg-success/90 transition-colors px-6 py-2.5'
              >
                <span className='uppercase tracking-wide'>Invitar</span>
                {faPaperPlane && <FontAwesomeIcon className="" size='lg' icon={faPaperPlane} />}
              </button>
            </PlanRestrictedButton>
          </ul>
        </Form>
      </Formik>
    </div>
  )
}
